import { FC, useEffect, useRef, useState } from 'react';

import { useRefEffect } from '@/Components/Hooks';

import { Icon } from '../Icon';
import { Base } from './base';
import { ItemProps, UploadProps } from './types';

export const File: FC<UploadProps> = (props) => {
    return (
        <Base
            {...props}
            className={'file'}
            uploadRender={({ ref, handleClick, isDragging, error }) => (
                <div
                    className={'uploader__item uploader__item_upload' + (isDragging ? ' dragging' : '') + (error ? ' error' : '')}
                    onClick={handleClick}
                    ref={ref}
                >
                    <Icon name="download" />
                    Click to upload file
                </div>
            )}
            itemRender={(item, _index, { handleRemove }) => (
                <Item key={`${item.uuid}`} id={item.id} uuid={item.uuid} name={item.name} progress={item.progress} url={item.url} onRemove={handleRemove} />
            )}
        />
    );
};

const Item: React.FC<ItemProps> = ({ progress, url, name, id, onRemove, uuid }) => {
    const loaderRef = useRef<HTMLDivElement>(null),
        currentLoaderRef = useRef<HTMLDivElement>(null);

    const [percent, setPercent] = useState<number | undefined>(id ? undefined : 0);
    const handleRemove = () => onRemove(uuid, id);

    useEffect(() => {
        if (progress === 100) setPercent(undefined);
        else if (progress) setPercent(progress);
    }, [progress]);

    useRefEffect(
        (currentLoader) => {
            if (progress) currentLoader.style.width = `${progress}%`;
        },
        [progress],
        currentLoaderRef
    );

    return (
        <div className={'uploader__item' + (percent !== undefined ? ' uploader__item_loading' : ' uploader__item_file')}>
            {percent !== undefined ? (
                <>
                    <div className="uploader__loader" ref={loaderRef}>
                        <div className="uploader__loader-current" ref={currentLoaderRef} />
                    </div>
                    <p>Uploading</p>
                </>
            ) : (
                <>
                    <p>{name}</p>
                    <Icon name="close" className="uploader-icon uploader__item_file-remove" size={20} onClick={handleRemove} />
                </>
            )}
        </div>
    );
};
